/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 * Polymorphic serializer base class.
 *
 * Note that the discriminator field must exist at the same depth as the mapped
 * serializer fields for the OpenAPI introspection. See
 * https://swagger.io/docs/specification/data-models/inheritance-and-polymorphism/ for
 * more information. As such, it's not possible to define something like:
 *
 * {
 *     "object_type": "foo",
 *     "polymorphic_context": {
 *         <foo-specific fields>
 *     }
 * }
 *
 * without explicitly wrapping this in a parent serializer, i.e. -
 * ``polymorphic_context`` can not be a PolymorphicSerializer itself, as it requires
 * access to the ``object_type`` in the parent scope.
 * @export
 * @interface VoiceAgentInferencerPolymorphicShared
 */
export interface VoiceAgentInferencerPolymorphicShared {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerPolymorphicShared
   */
  protocol: VoiceAgentProtocolEnum;
}

/**
 * Check if a given object implements the VoiceAgentInferencerPolymorphicShared interface.
 */
export function instanceOfVoiceAgentInferencerPolymorphicShared(
  value: object,
): value is VoiceAgentInferencerPolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerPolymorphicSharedFromJSON(json: any): VoiceAgentInferencerPolymorphicShared {
  return VoiceAgentInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function VoiceAgentInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
  };
}

export function VoiceAgentInferencerPolymorphicSharedToJSON(value?: VoiceAgentInferencerPolymorphicShared | null): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
  };
}
